export const PILL_STYLES = {
  'white-blue-stroke': {
    fill: 'rgb(255,255,255)',
    stroke: 'rgb(0,48,235)',
    textFill: 'rgb(0,48,235)'
  },
  'blue-white-stroke': {
    fill: 'rgb(0,48,235)',
    stroke: 'rgb(0,48,235)',
    textFill: 'rgb(255,255,255)'
  },
  'pink-white-text': {
    fill: 'rgb(255,112,206)',
    stroke: 'rgb(255,112,206)',
    textFill: '#FFFFFF'
  },
  'gold-white-text': {
    fill: 'rgb(199,180,125)',
    stroke: 'rgb(199,180,125)',
    textFill: '#FFFFFF'
  },
  'white-pink-text': {
    fill: 'rgb(255,255,255)',
    stroke: 'rgb(255,112,206)',
    textFill: 'rgb(255,112,206)'
  },
  'white-black-text': {
    fill: 'rgb(255,255,255)',
    stroke: 'rgb(0,0,0)',
    textFill: 'rgb(0,0,0)'
  }
} as const;

export type PillStyleName = keyof typeof PILL_STYLES;
